import { KeyboardEvent } from "react";

/** Lets a crop tile open the evidence drawer like a button: by click, Enter or Space. */
export const getEvidenceTriggerProps = (label: string, onOpen: () => void) => ({
  role: "button",
  tabIndex: 0,
  "aria-label": label,
  onClick: onOpen,
  onKeyDown: (event: KeyboardEvent<HTMLElement>) => {
    if (event.key !== "Enter" && event.key !== " ") return;
    event.preventDefault();
    onOpen();
  },
});
